import { Product } from "@/types/Products";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";

export default function ProductSelectionDropdown({
    tableInstance,
    selectedProducts,
    totalCount,
    products,
    setSelectedProducts,
    setPageSelections,
    handleSelectAll,
}: {
    tableInstance: any;
    selectedProducts: Product[];
    totalCount: number;
    products: Product[];
    setSelectedProducts: (products: Product[]) => void;
    setPageSelections: (
        selections: Record<number, Record<string, boolean>>
    ) => void;
    handleSelectAll: () => void;
}) {
    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button
                    variant="ghost"
                    size="sm"
                    className="-ml-3 h-8 data-[state=open]:bg-accent"
                >
                    <Checkbox
                        checked={
                            selectedProducts.length === totalCount ||
                            (selectedProducts.length > 0 &&
                                selectedProducts.length < totalCount &&
                                "indeterminate")
                        }
                        onCheckedChange={(value) => {
                            if (value) {
                                setSelectedProducts([...products]);
                            } else {
                                setSelectedProducts([]);
                            }
                            tableInstance.toggleAllPageRowsSelected(!!value);
                        }}
                        aria-label="Select all"
                    />
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="start">
                <DropdownMenuItem onClick={handleSelectAll}>
                    {totalCount > 1000 ? "Select first 1000" : "Select all"}
                </DropdownMenuItem>
                <DropdownMenuItem
                    onClick={() => {
                        setSelectedProducts([]);
                        // Clear selection state for all pages
                        setPageSelections({});
                        // Clear current page selection
                        tableInstance.toggleAllPageRowsSelected(false);
                    }}
                >
                    Deselect all
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
